import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './scrollDecoration.css';
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { ViewPart } from '../../view/viewPart.js';
import { scrollbarShadow } from '../../../../platform/theme/common/colorRegistry.js';
import { registerThemingParticipant } from '../../../../platform/theme/common/themeService.js';
export var ScrollDecorationViewPart = /*#__PURE__*/function (_ViewPart) {
  _inherits(ScrollDecorationViewPart, _ViewPart);

  var _super = _createSuper(ScrollDecorationViewPart);

  function ScrollDecorationViewPart(context) {
    var _this;

    _classCallCheck(this, ScrollDecorationViewPart);

    _this = _super.call(this, context);
    _this._scrollTop = 0;
    _this._width = 0;

    _this._updateWidth();

    _this._shouldShow = false;
    var options = _this._context.configuration.options;
    var scrollbar = options.get(84
    /* scrollbar */
    );
    _this._useShadows = scrollbar.useShadows;
    _this._domNode = createFastDomNode(document.createElement('div'));

    _this._domNode.setAttribute('role', 'presentation');

    _this._domNode.setAttribute('aria-hidden', 'true');

    return _this;
  }

  _createClass(ScrollDecorationViewPart, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ScrollDecorationViewPart.prototype), "dispose", this).call(this);
    }
  }, {
    key: "_updateShouldShow",
    value: function _updateShouldShow() {
      var newShouldShow = this._useShadows && this._scrollTop > 0;

      if (this._shouldShow !== newShouldShow) {
        this._shouldShow = newShouldShow;
        return true;
      }

      return false;
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    }
  }, {
    key: "_updateWidth",
    value: function _updateWidth() {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );

      if (layoutInfo.minimap.renderMinimap === 0 || layoutInfo.minimap.minimapWidth > 0 && layoutInfo.minimap.minimapLeft === 0) {
        this._width = layoutInfo.width;
      } else {
        this._width = layoutInfo.width - layoutInfo.minimap.minimapWidth - layoutInfo.verticalScrollbarWidth;
      }
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var scrollbar = options.get(84
      /* scrollbar */
      );
      this._useShadows = scrollbar.useShadows;

      this._updateWidth();

      this._updateShouldShow();

      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      this._scrollTop = e.scrollTop;
      return this._updateShouldShow();
    } // --- end event handlers

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {// Nothing to read
    }
  }, {
    key: "render",
    value: function render(ctx) {
      this._domNode.setWidth(this._width);

      this._domNode.setClassName(this._shouldShow ? 'scroll-decoration' : '');
    }
  }]);

  return ScrollDecorationViewPart;
}(ViewPart);
registerThemingParticipant(function (theme, collector) {
  var shadow = theme.getColor(scrollbarShadow);

  if (shadow) {
    collector.addRule(".monaco-editor .scroll-decoration { box-shadow: ".concat(shadow, " 0 6px 6px -6px inset; }"));
  }
});